import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, CtaBand } from "@/components/sections";
import { industries } from "@/config/site";
import { getCampaign } from "@/data/campaigns";

// Map industry slugs to a campaign landing page where one exists.
const CAMPAIGN_FOR = {
  "medical-professionals": "accounting-for-medical-professionals",
  "legal-professionals": "accounting-for-legal-professionals",
  consultants: "accounting-for-consultants",
  contractors: "accounting-for-contractors",
  "small-business": "small-business-accounting",
};

export default function WhoWeHelp() {
  return (
    <>
      <Seo
        title="Who We Help — Accounting for Professionals & Businesses"
        description="Bonsai Financial supports medical and legal professionals, engineers, consultants, contractors, entrepreneurs and small to medium businesses across South Africa."
        path="/who-we-help"
      />
      <PageHeader
        eyebrow="Who We Help"
        title="Support for professionals, entrepreneurs and growing businesses."
        intro="These are the kinds of clients Bonsai Financial is well positioned to help. We work with individuals and businesses alike — and we're happy to assist even if you're not sure where you fit."
      />

      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {industries.map((ind, i) => {
              const campaignSlug = CAMPAIGN_FOR[ind.slug];
              const hasCampaign = campaignSlug && getCampaign(campaignSlug);
              return (
                <div
                  key={ind.slug}
                  data-testid={`industry-card-${ind.slug}`}
                  className="flex flex-col rounded-2xl border border-slate-200/80 bg-white p-7 transition-shadow hover:shadow-md"
                >
                  <h3 className="font-display text-lg font-semibold text-[#18201B]">{ind.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-[#526057]">{ind.challenge}</p>
                  {hasCampaign ? (
                    <Link
                      to={`/${campaignSlug}`}
                      data-testid={`industry-link-${ind.slug}`}
                      className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2C5E43] hover:text-[#133827]"
                    >
                      Learn more <ArrowRight className="h-4 w-4" />
                    </Link>
                  ) : (
                    <Link
                      to="/assessment"
                      data-testid={`industry-link-${ind.slug}`}
                      className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2C5E43] hover:text-[#133827]"
                    >
                      Request a consultation <ArrowRight className="h-4 w-4" />
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
          <p className="mt-10 max-w-3xl text-sm text-[#526057]">
            These are initial market focuses, not exclusive specialisations. Bonsai Financial works
            with a broad range of individuals and businesses across South Africa.
          </p>
        </div>
      </section>

      <CtaBand from="who-we-help-cta" />
    </>
  );
}
